import type { LocalizationMap } from './Localization/Localization';
// --------------------------------------------------------------------------------
export const RsDateRangePickerLocalizationTextMapKey: string = 'Primitive_RsDateRangePicker';
// --------------------------------------------------------------------------------
export const enum RsDateRangePickerLocalizationLabelKey {
    sunday = 'sunday',
    monday = 'monday',
    tuesday = 'tuesday',
    wednesday = 'wednesday',
    thursday = 'thursday',
    friday = 'friday',
    saturday = 'saturday',
    ok = 'ok',
    today = 'today',
    yesterday = 'yesterday',
    hours = 'hours',
    minutes = 'minutes',
    seconds = 'seconds',
    last7Days = 'last7Days',
    thisWeek = 'thisWeek',
    last30Days = 'last30Days',
    thisMonth = 'thisMonth',
    lastMonth = 'lastMonth',
    thisYear = 'thisYear',
    lastYear = 'lastYear',
    back = 'back',
    forth = 'forth'
}
// --------------------------------------------------------------------------------
export function GetRsDateRangePickerLocalizationDictionary(): LocalizationMap {
    return {
        [RsDateRangePickerLocalizationLabelKey.sunday]: 'Su',
        [RsDateRangePickerLocalizationLabelKey.monday]: 'Mo',
        [RsDateRangePickerLocalizationLabelKey.tuesday]: 'Tu',
        [RsDateRangePickerLocalizationLabelKey.wednesday]: 'We',
        [RsDateRangePickerLocalizationLabelKey.thursday]: 'Th',
        [RsDateRangePickerLocalizationLabelKey.friday]: 'Fr',
        [RsDateRangePickerLocalizationLabelKey.saturday]: 'Sa',
        [RsDateRangePickerLocalizationLabelKey.ok]: 'OK',
        [RsDateRangePickerLocalizationLabelKey.today]: 'Today',
        [RsDateRangePickerLocalizationLabelKey.yesterday]: 'Yesterday',
        [RsDateRangePickerLocalizationLabelKey.hours]: 'Hours',
        [RsDateRangePickerLocalizationLabelKey.minutes]: 'Minutes',
        [RsDateRangePickerLocalizationLabelKey.seconds]: 'Seconds',
        [RsDateRangePickerLocalizationLabelKey.last7Days]: 'Last 7 Days',
        [RsDateRangePickerLocalizationLabelKey.thisWeek]: 'This week',
        [RsDateRangePickerLocalizationLabelKey.last30Days]: 'Last 30 days',
        [RsDateRangePickerLocalizationLabelKey.thisMonth]: 'This month',
        [RsDateRangePickerLocalizationLabelKey.lastMonth]: 'Last month',
        [RsDateRangePickerLocalizationLabelKey.thisYear]: 'This year',
        [RsDateRangePickerLocalizationLabelKey.lastYear]: 'Last year',
        [RsDateRangePickerLocalizationLabelKey.back]: 'Back',
        [RsDateRangePickerLocalizationLabelKey.forth]: 'Forth'
    };
}
// --------------------------------------------------------------------------------